import React from "react";
import PropTypes from "prop-types";

import ReactPlayer from "react-player/lazy";
import VideoPlayerWrap from "./style/wrap";

const VideoPlayer = ({ url }) => {
  return (
    <VideoPlayerWrap>
      <ReactPlayer url={url} width="100%" height="100%" />
    </VideoPlayerWrap>
  );
};

VideoPlayer.propTypes = {
  url: PropTypes.string.isRequired,
};

export default VideoPlayer;
